import styled from 'styled-components';

export const BlueDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: var(--brand-blue);
  border-radius: 100%;
  margin-right: 15px;
`;
